//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ReceiptInvoicePDF",

  props: {
    main_data: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      pdfMakeReady: false,
      // ข้อมูลจำลองสำหรับทดสอบ (ใช้เมื่อไม่มี prop)
      mockData: {
        main_data: {
          datashowAll: [
            [
              {
                no: 1,
                inv_id: "INV230004",
                date: "08/02/2023",
                credit_term: 0,
                currency: "US",
                amount: 725.46,
                amount_s: 725.46,
                amount_s_ex: 24934.06,
                amount_sub: "678.00",
                lastdata: "lastindex",
              },
            ],
          ],
          print_header: {
            id: "1",
            com_title: "RECEIPT / TAX INVOICE",
            com_title_th: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            com_name: "",
            inv_company_name_th: "",
            inv_company_address: "",
            inv_company_branch: "",
            inv_company_tel: "",
            inv_company_email: "",
            inv_tax_id: "",
            com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
            com_eng_2: "ATTORNEY AT LAW",
            com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
            com_add_name: "CHARN ISSARA TOWER 2nd FLOOR, 942/69 RAMA IV ROAD,",
            com_add_no: "",
            com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
            com_add_country: "BANGKOK 10500, THAILAND",
            com_add_tel: "Tel : 0-2233-0055, 0-2233-0068",
            com_add_email: "E-MAIL : account@dejudom.com",
            com_add_tax_id: 'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
            payment_by: "Other",
            payment_detail: "",
            inv_id: "DR230031",
            invoice_date: "03/07/2023",
            wth_rate: "0.00",
            tax_rate: "7.00",
            wth_rate_amount: 0,
            customer_name: "Newland Chase",
            addressall:
              "135 Cecil Street, #07-02 MYP Plaza\n\n,\nSingapore\nSingapore",
            customer_address: "135 Cecil Street, #07-02 MYP Plaza  Singapore",
            province_invoice: "",
            country_invoice: "Singapore",
            zipcode_invoice: "Singapore",
            period_cover: "INV230004",
            customer_contact_name: "MR.Pham Duy Tien",
            customer_taxid: "0000000000",
            amount_total_oth: 725.46,
            sub_total_oth: 678,
            tax_rate_amount_oth: 47.460000000000036,
            amount_total: 24934.06,
            sub_total: 23302.86,
            tax_rate_amount: 1631.2000000000007,
          },
          heighttabledetail: "270px",
          currency_print: "US",
          check_cus_name: true,
          textamount_total_en:
            "Twenty-four Thousand Nine Hundred Thirty-four Point Zero Six",
          checklawoffice: false,
          exchange_rate: "34.37",
          branch_cus: null,
          payment_by_print: "",
          bank_name_show: null,
          bank_no_show: null,
        },
      },
    };
  },

  computed: {
    // ใช้ข้อมูลจาก prop ถ้ามี ไม่งั้นใช้ mockData
    dataToUse() {
      return this.main_data || this.mockData.main_data;
    },

    header() {
      return this.dataToUse.print_header || {};
    },

    items() {
      // แปลงข้อมูลจาก datashowAll ให้อยู่ในรูปแบบที่ใช้งานได้
      const datashowAll = this.dataToUse.datashowAll || [];
      const allItems = [];

      datashowAll.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    currencyPrint() {
      return this.dataToUse.currency_print || "";
    },

    exchangeRate() {
      return this.dataToUse.exchange_rate || "";
    },

    // ตรวจสอบว่าต้องแสดงคอลัมน์ Currency/Amount หรือไม่
    showCurrencyColumn() {
      const curr = this.currencyPrint.toUpperCase();
      return curr === "US" || curr === "USD";
    },
  },

  mounted() {
    this.$hideLoader();
    this.waitForPdfMakeReady()
      .then(() => {
        this.pdfMakeReady = true;
        console.log("✅ pdfMake พร้อมใช้งาน");
      })
      .catch((error) => {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("ไม่สามารถโหลด pdfMake ได้ กรุณาลองใหม่อีกครั้ง");
      });
  },

  methods: {
    // ====================================================================
    // ฟังชั่นรอให้ pdfMake พร้อมใช้งาน
    // ====================================================================
    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);
            console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตตัวเลข
    // ====================================================================
    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตวันที่
    // ====================================================================
    formatDate(dateString) {
      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    // ====================================================================
    // ฟังชั่นสร้าง Header ของเอกสาร
    // ====================================================================
    createHeader() {
      return {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_eng_2 || "ATTORNEY AT LAW",
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_thai ||
                  "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                fontSize: 8,
                margin: [0, 0, 0, 1],
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text:
                  this.header.com_add_name ||
                  "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_city ||
                  "KWAENG SURIYAWONG, KHET BANGRAK,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_country || "BANGKOK 10500, THAILAND",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_email || "E-MAIL : account@dejudom.com",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tax_id ||
                  'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                fontSize: 7,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้าง Title ของเอกสาร
    // ====================================================================
    createTitle() {
      return {
        stack: [
          {
            text: this.header.com_title || "RECEIPT / TAX INVOICE",
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 15, 0, 2],
          },
          {
            text: this.header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            fontSize: 12,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 10],
          },
        ],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างข้อมูลลูกค้า
    // ====================================================================
    createCustomerInfo() {
      const addressLines = (this.header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                columns: [
                  {
                    width: 60,
                    text: "To / ถึง:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: this.header.customer_name || "Customer Name",
                    fontSize: 9,
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "",
                    fontSize: 8,
                  },
                  {
                    width: "*",
                    text:
                      filteredAddress ||
                      "Address Line 1, address line 1, address line 1,\nAddress Line 2, address line 2, address line 2, address line 2\nAddress Line 3, address line 3, address line 3, address line 3\nCity, Postcode, COUNTRY",
                    fontSize: 8,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "Tax ID:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: this.header.customer_taxid || "__________________",
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          {
            width: "30%",
            stack: [
              {
                text: `No. / เลขที่ : ${this.header.inv_id || "________"}`,
                fontSize: 9,
                alignment: "right",
                margin: [0, 0, 0, 5],
              },
              {
                text: `Date / วันที่ : ${this.formatDate(
                  this.header.invoice_date,
                ) || "______________"}`,
                fontSize: 9,
                alignment: "right",
                margin: [0, 0, 0, 5],
              },
              {
                text: `Exchange Rate : ${this.exchangeRate ||
                  "______________"}`,
                fontSize: 9,
                alignment: "right",
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างตารางรายการ
    // ====================================================================
    createItemsTable() {
      // กำหนดความกว้างของคอลัมน์ตามเงื่อนไข
      const tableWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80] // มี Currency/Amount
        : [35, "*", 70, 80]; // ไม่มี Currency/Amount

      // สร้าง Header Row
      const headerRow = [
        {
          text: "No.",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Statement No./ เลขที่ใบเเจ้งหนี้",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Date / วันที่",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
      ];

      // เพิ่มคอลัมน์ Currency/Amount ถ้าจำเป็น
      if (this.showCurrencyColumn) {
        headerRow.push({
          text: "Currency / Amount",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        });
      }

      // เพิ่มคอลัมน์ Amount/จำนวนเงิน (THB)
      headerRow.push({
        text: "Amount / จำนวนเงิน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      });

      // สร้าง Body Rows
      const bodyRows = [];
      const minRows = 7; // ลดเป็น 7 แถว

      for (let i = 0; i < minRows; i++) {
        if (i < this.items.length) {
          const item = this.items[i];
          const row = [
            {
              text: item.no || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
            {
              text: item.inv_id || "",
              fontSize: 9,
              margin: [2, 3, 2, 3],
            },
            {
              text: this.formatDate(item.date) || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
          ];

          // เพิ่มคอลัมน์ Currency/Amount ถ้าจำเป็น
          if (this.showCurrencyColumn) {
            row.push({
              text: item.amount ? this.formatNumber(item.amount) : "",
              fontSize: 9,
              alignment: "right",
              margin: [2, 3, 2, 3],
            });
          }

          // เพิ่มคอลัมน์ Amount THB
          row.push({
            text: item.amount_s_ex ? this.formatNumber(item.amount_s_ex) : "",
            fontSize: 9,
            alignment: "right",
            margin: [2, 3, 2, 3],
          });

          bodyRows.push(row);
        } else {
          // แถวว่าง
          const emptyRow = [
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
          ];

          if (this.showCurrencyColumn) {
            emptyRow.push({
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            });
          }

          emptyRow.push({
            text: "",
            fontSize: 9,
            margin: [2, 15, 2, 15],
          });
          bodyRows.push(emptyRow);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [headerRow, ...bodyRows],
        },
        layout: {
          hLineWidth: function(i, node) {
            // แสดงเส้นบนสุด (i=0), เส้นใต้ header (i=1), และเส้นล่างสุด
            // if (i === 0 || i === 1 || i === node.table.body.length) {
            if (i === 0 || i === 1) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function(i) {
            return 1;
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วนสรุปยอดเงิน
    // ====================================================================
    createSummaryTable() {
      const subTotal = this.header.sub_total || 0;
      const subTotalOth = this.header.sub_total_oth || 0;
      const taxRate = this.header.tax_rate || "7.00";
      const taxAmount = this.header.tax_rate_amount || 0;
      const taxAmountOth = this.header.tax_rate_amount_oth || 0;
      const grandTotal = this.header.amount_total || 0;
      const grandTotalOth = this.header.amount_total_oth || 0;
      let currency = this.currencyPrint || "USD";
      currency = currency.replace("US", "USD");
      currency = currency.replace("USDD", "USD");

      // กำหนดความกว้างคอลัมน์ตามว่ามี Currency column หรือไม่
      const summaryWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80] // มี Currency/Amount
        : [35, "*", 70, 80]; // ไม่มี Currency/Amount

      // สร้างแถวสรุป
      const summaryRows = [];

      // แถว Sub Total
      const subTotalRow = [
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },

        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        subTotalRow.push({
          text: `${currency} ${this.formatNumber(subTotalOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      subTotalRow.push({
        text: this.formatNumber(subTotal),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(subTotalRow);

      // แถว VAT
      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        vatRow.push({
          text: `${currency} ${this.formatNumber(taxAmountOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      vatRow.push({
        text: this.formatNumber(taxAmount),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(vatRow);

      // แถว Grand Total
      const grandTotalRow = [
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        grandTotalRow.push({
          text: `${currency} ${this.formatNumber(grandTotalOth)}`,
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      grandTotalRow.push({
        text: this.formatNumber(grandTotal),
        fontSize: 9,
        bold: true,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(grandTotalRow);

      return {
        table: {
          widths: summaryWidths,
          body: summaryRows,
        },
        layout: {
          hLineWidth: function(i, node) {
            // แสดง border แนวนอนทุกเส้น
            return 1;
          },
          vLineWidth: function(i) {
            // แสดง border แนวตั้งทุกเส้น
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วนยอดเงินเป็นตัวอักษร
    // ====================================================================
    createAmountInWords() {
      const amountText = this.dataToUse.textamount_total_en || "";

      // กำหนดความกว้างคอลัมน์ตามว่ามี Currency column หรือไม่
      const widths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80] // มี Currency/Amount
        : [35, "*", 70, 80]; // ไม่มี Currency/Amount

      // สร้างแถวที่มี colspan
      const cells = [
        {
          text: `(${amountText}) THB`,
          fontSize: 9,
          alignment: "center",
          margin: [5, 8, 5, 8],
          fillColor: "#d8d8d8",
          colSpan: this.showCurrencyColumn ? 5 : 4,
        },
        {},
      ];

      // เพิ่มเซลล์ว่างสำหรับ colspan
      const emptyCellCount = this.showCurrencyColumn ? 3 : 2;
      for (let i = 0; i < emptyCellCount; i++) {
        cells.push({});
      }

      return {
        table: {
          widths: widths,
          body: [cells],
        },
        layout: {
          hLineWidth: function() {
            return 0;
          },
          vLineWidth: function() {
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วน Payment Conditions (กล่องแยกอิสระ)
    // ====================================================================
    createPaymentConditions() {
      const paymentDetail = this.dataToUse.payment_by_print || "";

      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                stack: [
                  {
                    text: "Payment Conditions:",
                    fontSize: 9,
                    bold: true,
                    margin: [2, 5, 2, 3],
                  },
                  {
                    columns: [
                      {
                        width: "25%",
                        text: "☐ Cash/เงินสด",
                        fontSize: 9,
                        margin: [10, 0, 0, 0],
                      },
                      {
                        width: "25%",
                        text: "☐ Transfer/โอนเงิน",
                        fontSize: 9,
                      },
                      {
                        width: "30%",
                        text: "☐ Cheque/เช็คธนาคาร",
                        fontSize: 9,
                      },
                      {
                        width: "20%",
                        text: "No./เลขที่",
                        fontSize: 9,
                      },
                    ],
                    margin: [2, 3, 2, 5],
                  },
                ],
                margin: [2, 0, 2, 0],
              },
            ],
            [
              {
                text: `Payment Details / รายละเอียด:${
                  paymentDetail ? "  " + paymentDetail : ""
                }`,
                fontSize: 9,
                margin: [2, 5, 2, 20],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            // border บนสุดและล่างสุด
            if (i === 0 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function() {
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 15],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วนลายเซ็น (กล่องแยกด้านขวา)
    // ====================================================================
    createSignatureBox() {
      return {
        columns: [
          {
            width: "50%",
            text: "",
          },
          {
            width: "50%",
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    stack: [
                      {
                        text: "",
                        margin: [0, 0, 0, 35],
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 30,
                            y1: 0,
                            x2: 200,
                            y2: 0,
                            lineWidth: 1,
                          },
                        ],
                        margin: [0, 0, 0, 5],
                      },
                      {
                        text: "Authorized Signature / ผู้รับเงิน",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                      {
                        text: "Date/วันที่ _______________________",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                    ],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function() {
                return 1;
              },
              vLineWidth: function() {
                return 1;
              },
              hLineColor: function() {
                return "black";
              },
              vLineColor: function() {
                return "black";
              },
            },
          },
        ],
        margin: [0, 0, 0, 15],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วน Footer Note
    // ====================================================================
    createFooterNote() {
      return {
        stack: [
          {
            text:
              "This receipt will be valid whgn the company has received the payment into the bank account.",
            fontSize: 8,
            alignment: "center",
            margin: [0, 5, 0, 0],
          },
          {
            text:
              "ใบเสร็จรับเงินนี้จะสมบูรณ์เมื่อบริษัทได้รับชำระเงินเข้าในบัญชีธนาคารเรียบร้อยแล้ว",
            fontSize: 8,
            alignment: "center",
          },
        ],
        margin: [0, 10, 0, 0],
      };
    },

    // ====================================================================
    // ฟังชั่นสร้างเอกสาร PDF หลัก
    // ====================================================================
    generateMainReceipt() {
      const mainContent = [];

      // เพิ่มแต่ละส่วนของเอกสาร
      mainContent.push(this.createHeader());
      mainContent.push(this.createTitle());
      mainContent.push(this.createCustomerInfo());
      mainContent.push(this.createItemsTable());
      mainContent.push(this.createSummaryTable());
      mainContent.push(this.createAmountInWords());
      mainContent.push(this.createPaymentConditions());
      mainContent.push(this.createSignatureBox());
      mainContent.push(this.createFooterNote());

      return mainContent;
    },

    // ====================================================================
    // ฟังชั่นสร้าง Document Definition สำหรับ pdfMake
    // ====================================================================
    generateDocDefinition() {
      const mainReceipt = this.generateMainReceipt();

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainReceipt,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },

    // ====================================================================
    // ฟังชั่นดูตัวอย่าง PDF
    // ====================================================================
    previewPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        pdfMake.createPdf(docDefinition).open();
        console.log("✅ เปิดตัวอย่าง PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    // ====================================================================
    // ฟังชั่นดาวน์โหลด PDF
    // ====================================================================
    downloadPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        const fileName = `Receipt_${this.header.inv_id ||
          "document"}_${this.formatDate(this.header.invoice_date) || ""}.pdf`;
        pdfMake.createPdf(docDefinition).download(fileName);
        console.log("✅ ดาวน์โหลด PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการดาวน์โหลด PDF: " + error.message);
      }
    },

    // ====================================================================
    // ฟังชั่นพิมพ์ PDF
    // ====================================================================
    printPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        pdfMake.createPdf(docDefinition).print();
        console.log("✅ สั่งพิมพ์ PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการพิมพ์ PDF: " + error.message);
      }
    },
  },
};
